import { FILE_TYPES } from '../../../formFileTypesEnum';
import { VENDORS } from '../../../formQuestionsEnum';

export const EMERGENCY_SERVICE_VENDOR_FIELDS = [
  {
    question: VENDORS.TRANSPORTATION_VENDOR,
    title: 'Transportation outsourced company',
    invoiceFileTypeId: FILE_TYPES.TRANSPORTATION_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.TRANSPORTATION_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.EMERGENCY_ICE_VENDOR,
    title: 'Emergency ice',
    invoiceFileTypeId: FILE_TYPES.EMERGENCY_ICE_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.EMERGENCY_ICE_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.EMERGENCY_WATER_VENDOR,
    title: 'Emergency water',
    invoiceFileTypeId: FILE_TYPES.EMERGENCY_WATER_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.EMERGENCY_WATER_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.PETROLEUM_PROVIDER,
    title: 'Petroleum provider',
    invoiceFileTypeId: FILE_TYPES.PETROLEUM_PROVIDER_INVOICE,
    contractFileTypeId: FILE_TYPES.PETROLEUM_PROVIDER_CONTRACT,
  },
  {
    question: VENDORS.RECIPROCAL_TRANSFER_AGREEMENT_VENDOR,
    title: 'Reciprocal transfer agreement (disaster evac)',
    invoiceFileTypeId: FILE_TYPES.RECIPROCAL_TRANSFER_AGREEMENT_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.RECIPROCAL_TRANSFER_AGREEMENT_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.REFRIGERATED_TRUCK_VENDOR,
    title: 'Refrigerated truck',
    invoiceFileTypeId: FILE_TYPES.REFRIGERATED_TRUCK_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.REFRIGERATED_TRUCK_VENDOR_CONTRACT,
  },
];
